import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import PreviewItem from './PreviewItem';

export default function PreviewPanel({
  captures,
  selectedIdx,
  onSelect,
  onUpload,
  onMatch,
  onDelete,
  uploading,
  processing,
  processingImage,
  showBoundingBoxes,
  immediateFaceMatch,
  fileInputRef
}) {
  return (
    <Box sx={{
      flex: 0.7,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0,
      overflow: 'hidden',
      position: { xs: 'absolute', md: 'relative' },
      top: { xs: 0, md: 'auto' },
      right: { xs: 0, md: 'auto' },
      height: '100%',
      width: { xs: '30vw', md: 'auto' },
      backgroundColor: { xs: 'rgba(255,255,255,0.9)', md: 'transparent' },
      boxShadow: { xs: '-6px 0 12px rgba(0,0,0,0.15)', md: 'none' },
      zIndex: { xs: 1300, md: 'auto' },
      p: { xs: 0, md: 0 }
    }}>
      <Box sx={{
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
        overflow: 'auto',
        py: 1,
        '&::-webkit-scrollbar': {
          width: '6px'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'primary.main',
          borderRadius: '3px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: 'primary.dark'
        },
        scrollbarWidth: 'thin',
        scrollbarColor: 'primary.main transparent'
      }}>
        {processing && processingImage && (
          <Box sx={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
            <img src={processingImage} alt="processing" style={{ width: '25vw', maxWidth: '320px', height: 'auto', objectFit: 'contain', borderRadius: '6px', opacity: 0.6 }} />
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <CircularProgress />
            </Box>
          </Box>
        )}

        {captures.map((capture, idx) => {
          return (
            <Box key={capture.id} sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <PreviewItem
                src={capture.dataUrl}
                idx={idx}
                selected={selectedIdx === idx}
                onSelect={(i) => onSelect(i)}
                onUpload={(i) => onUpload(i)}
                onMatch={(i) => onMatch(i)}
                onDelete={onDelete}
                uploading={uploading}
                processing={capture.processing}
                boundingBox={capture.boundingBox}
                boundingBoxes={capture.boundingBoxes || (capture.boundingBox ? [capture.boundingBox] : [])}
                clusterMetadata={capture.clusterMetadata}
                showBoundingBox={showBoundingBoxes}
                immediateFaceMatch={immediateFaceMatch}
                matchFailed={capture.matchFailed}
                captureId={capture.id}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
